import moment from "moment-timezone";
import { User } from "../../store/store";

import { Apollo } from "@/decorators";
import { Document } from "../../../../types";
import { Invoice } from "../../../../types";

import UPDATE_DOCUMENT_TAGS from "../../graphql/document/UpdateDocumentsTags.gql";
import UPDATE_INVOICE_TAGS from "../../graphql/invoice/UpdateInvoicesTags.gql";
import UPDATE_BANKTRANSACTION_TAGS from "../../graphql/document/UpdateBankTransactionsTags.gql";
import UPDATE_ACCOUNTINGLINE_TAGS from "../../graphql/tag/UpdateAccountingLineTags.gql";
import DOCUMENT_TAG_SUGGESTION_QUERY from "../../graphql/tag/DocumentTagSuggestions.gql";
import THIRDPARTYCOMPANY_TAGS_QUERY from "../../graphql/tag/ThirdPartyCompanyTags.gql";
import CREATE_THIRDPARTYCOMPANY_TAG_RULE from "../../graphql/tag/CreateThirdPartyCompanyTagRule.gql";
import ACCOUNTINGLINE_TAGS_QUERY from "../../graphql/tag/AccountingLineTags.gql";
import UPDATE_TAGS_QUERY from "../../graphql/tag/UpdateTags.gql";

import { getTagColor, getTagDocumentTypes } from "../../services/tagServices";
import { UserActivity } from "../../services/userActivityServices";
import { Component, Vue } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";
import { State2Way } from "@/decorators";
// import { buildPartitionTagsFromCompanyTags } from "../../services/tagServices";

@Component({
    emits: [
        "focus",
        "blur",
        "updateTags",
        "onTagsChanged",
        "tagRuleApplyOnThirdPartyCompany",
        "closeDialog",
    ],
})
export class FreeTagBase extends Vue {
    @Prop({ default: null }) company;

    @Prop({ default: null }) document: Document;
    @Prop({ default: null }) bankTransaction;

    @Prop({ default: null }) selectedDocuments;
    @Prop({ default: null }) selectedBankTransactions;
    @Prop({ default: null }) selectedAccountingLines;

    @Prop({ default: null }) documentType;
    @Prop({ default: null }) accountingLine;

    @Prop({ default: null }) invoiceProduct;

    @Prop({ default: null }) invoice: Invoice;

    @Prop({ default: null }) companyUser;

    @Prop({ default: false }) outlined: boolean;
    @Prop({ default: false }) createIfMissing: boolean;

    @Prop({ default: null }) inPrimaryLog: string;
    @Prop({ default: null }) inLogTagId: string;
    @Prop({ default: [] }) companyTags: Tag[];
    // @Prop() id;

    @Prop({ default: true }) onlyOneByPartition: boolean;
    @Prop({ default: null }) partitionTagId: string;

    @Prop({ default: false }) splitUserPartitions: boolean;

    @Prop({ default: true }) multiple: boolean;

    @Model({ default: null, name: "inDialog" }) syncedInDialog: boolean;
    // @Prop({ default: null }) inDialog: boolean
    // get syncedInDialog() {
    //     return this.inDialog
    // }

    @State2Way("updateTagExpandPartitions", "tags.expandPartitions")
    expanded: boolean;

    activator = null;

    attach = null;

    editing = null;

    index = -1;

    menu = false;

    model = [];

    x = 0;

    y = 0;

    search = null;
    searchText = "";

    dialog_: boolean = false;

    // dialog: boolean = false;

    activity: any;

    timeGate: boolean = true;

    get dialog() {
        if (this.syncedInDialog === null) {
            return this.dialog_;
        }
        return this.syncedInDialog;
    }

    set dialog(value) {
        if (this.syncedInDialog === null) {
            this.dialog_ = value;
        } else {
            // if (!value) {
            //     this.$emit("closeDialog")
            // }
            this.syncedInDialog = value;
        }
    }

    get isExpandable() {
        if (!this.splitUserPartitions) {
            return false;
        }
        if (this.partitionTags?.length <= 1) {
            return false;
        }
        return true;
    }

    get visiblePartitions() {
        return this.splitUserPartitions && this.expanded ? this.partitionTags : [];
    }

    // @Watch("isExpandable")
    // oniIsExpandable(value) {
    //     if (this.isExpandable) {
    //         this.expanded = true;
    //     }
    // }

    // snackbar: boolean = false;
    // snackBarTag: any = null
    // snackbarLoading: boolean = false

    snackbar = {
        tag: null,
        thirdPartyCompany: null,
        display: false,
        loading: false,
    };

    dialogTagManager = false;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get companyId() {
        if (this.document?.company?.id) {
            return this.document.company.id;
        }
        if (this.invoice?.company?.id) {
            return this.invoice.company.id;
        }
        if (this.accountingLine?.company?.id) {
            return this.accountingLine.company.id;
        }
        if (this.company) {
            return this.company.id;
        }
        return undefined;
    }

    get docmentId() {
        if (this.document) return this.document.id;
        return "";
    }

    get bankTransactionId() {
        if (this.bankTransaction) return this.bankTransaction.id;
        return "";
    }

    get accountingLineId() {
        if (this.accountingLine) return this.accountingLine.id;
        return "";
    }

    get selectedAccountingLinesCount() {
        return this.selectedAccountingLines.length;
    }

    get companyUserId() {
        if (this.companyUser) return this.companyUser.id;
        return "";
    }

    get invoiceProductId() {
        if (this.invoiceProduct) return this.invoiceProduct.id;
        return "";
    }

    get invoiceId() {
        if (this.invoice) return this.invoice.id;
        return "";
    }

    get thirdPartyCompany() {
        if (this.document) {
            return this.document.thirdPartyCompany;
        }
        if (this.invoice) {
            return this.invoice.client;
        }
        if (this.accountingLine) {
            return this.accountingLine.thirdPartyCompany;
        }
        return undefined;
    }

    get thirdPartyCompanyIds() {
        if (this.document) {
            if (this.document.thirdPartyCompany?.id) {
                return [this.document.thirdPartyCompany.id];
            }
        } else if (this.invoice) {
            if (this.invoice.client?.id) {
                return [this.invoice.client.id];
            }
        } else if (this.accountingLine) {
            if (this.accountingLine.thirdPartyCompany?.id) {
                return [this.accountingLine.thirdPartyCompany.id];
            }
        } else if (this.selectedDocuments) {
            const thirdPartyCompanies = [];
            for (const document of this.selectedDocuments) {
                if (document.thirdPartyCompany?.id) {
                    thirdPartyCompanies.push(document.thirdPartyCompany.id);
                }
            }
            return thirdPartyCompanies;
        } else if (this.selectedBankTransactions) {
            const thirdPartyCompanies = [];
            for (const bankTransaction of this.selectedBankTransactions) {
                if (bankTransaction.thirdPartyCompany?.id) {
                    thirdPartyCompanies.push(bankTransaction.thirdPartyCompany.id);
                }
            }
            return thirdPartyCompanies;
        } else if (this.selectedAccountingLines) {
            const thirdPartyCompanies = [];
            for (const accountingLine of this.selectedAccountingLines) {
                if (accountingLine.thirdPartyCompany?.id) {
                    thirdPartyCompanies.push(accountingLine.thirdPartyCompany.id);
                }
            }
            return thirdPartyCompanies;
        }
        return [];
    }

    onFocus(e) {
        if (e) {
            this.$emit("focus");
        } else {
            this.$emit("blur");
        }
    }

    @Apollo({
        query() {
            return DOCUMENT_TAG_SUGGESTION_QUERY;
        },
        variables() {
            return {
                documentId: this.document.id,
            };
        },
        debounce: 500,
        skip() {
            return !this.document || !this.document.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data) {
                this.tagSuggestions =
                    (data.documentTagSuggestions && data.documentTagSuggestions.tagSuggestions) ||
                    [];
                // if (this.tagSuggestions && this.tagSuggestions.length)
                // {
                //     debugger;
                // }
            }
        },
    })
    tagSuggestions: any[] = [];

    // get thirdPartyCompanyIds() {
    //     return this.thirdPartyCompanies.map(tpc => tpc.id).filter(id => !!id)
    // }

    @Apollo({
        query() {
            return THIRDPARTYCOMPANY_TAGS_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                thirdPartyCompanyIds: this.thirdPartyCompanyIds,
            };
        },
        debounce: 500,
        skip() {
            return !this.thirdPartyCompanyIds.length || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data && data.thirdPartyCompanyTags) {
                this.thirdPartyCompanyTags = data.thirdPartyCompanyTags;
            } else {
                this.thirdPartyCompanyTags = [];
            }
        },
    })
    thirdPartyCompanyTags: any[] = [];

    get filteredCompanyTags(): Tag[] {
        const tags: Tag[] = [];
        for (const tag of this.companyTags) {
            if (this.showTagName(tag)) {
                tags.push(tag);
            }
        }
        return tags;
    }

    get filteredAllCompanyTags() {
        const tags = [];
        for (const tag of this.companyTags) {
            if (this.showTagName(tag)) {
                if (this.searchText) {
                    if (tag.header) {
                        tags.push(tag);
                    } else if (tag.text.toLowerCase().includes(this.searchText.toLowerCase())) {
                        tags.push(tag);
                    }
                } else {
                    tags.push(tag);
                }
            }
        }
        return tags;
    }

    set filteredAllCompanyTags(tags) {
        debugger;
    }

    get internalDocumentType() {
        if (this.document?.type) {
            return this.document.type;
        }
        if (this.inPrimaryLog) {
            return this.inPrimaryLog;
        }
        return this.documentType;
    }

    showTagName(item) {
        if (this.internalDocumentType) {
            if (item.documentTypes) {
                return item.documentTypes.indexOf(this.internalDocumentType) !== -1;
            }
            if (item.primaryLog) {
                return item.primaryLog === this.internalDocumentType;
            }
        }
        return true;
    }

    getTagName(item) {
        // return truncate(item.text, 15);
        return item.text;
    }

    getTagNameToSelect(item) {
        // debugger;
        const text = item.text;
        const index = this.tagSuggestions.findIndex((suggestion) => suggestion.id === item.id);
        if (index !== -1) {
            return (
                text +
                " (" +
                Math.round(this.tagSuggestions[index].confidence * 100).toString() +
                "%)"
            );
        }
        return text;
    }

    addAccountableAccountTag(al, tags) {
        if (al.accountableAccount && al.accountableAccount.tag) {
            const tag = al.accountableAccount.tag;
            if (!tags.find((t) => t.id === tag.id)) {
                tag.disableDelete = true;
                tags.push(tag);
            }
        }
    }

    addInvoiceTag(inv, tags) {} //? MAXIME à faire ?

    @Watch("inLogTagId")
    onInLogTagIdChanged() {
        const tag = this.companyTags.find((t) => t.id === this.inLogTagId);
        for (let i = 0; i < this.model.length; i++) {
            const existingTag = this.model[i];
            if (existingTag.primaryLog) {
                if (tag) {
                    this.model.splice(i, 1, tag);
                } else {
                    this.model.splice(i, 1);
                }
                return;
            }
        }
        if (tag) {
            this.model.push(tag);
            this.emitTagsChanged();
        }
    }

    async updateModel() {
        let tags = [];
        let emitTagsChanged: boolean = false;
        if (this.document) {
            tags = this.document.tags;
            if (this.document.accountingLines) {
                for (const al of this.document.accountingLines) {
                    this.addAccountableAccountTag(al, tags);
                }
            }
        }
        if (this.bankTransaction) {
            tags = this.bankTransaction.tags;
            if (this.bankTransaction.accountingLines) {
                for (const al of this.bankTransaction.accountingLines) {
                    this.addAccountableAccountTag(al, tags);
                }
            }
        } else if (this.accountingLine?.id) {
            const result = await this.$apollo.query({
                query: ACCOUNTINGLINE_TAGS_QUERY,
                variables: {
                    accountingLineId: this.accountingLine.id,
                },
                fetchPolicy: "network-only",
            });
            if (result && result.data && result.data.accountingLine) {
                tags = result.data.accountingLine.tags;
                this.addAccountableAccountTag(result.data.accountingLine, tags);
            }
        } else if (this.inLogTagId) {
            const tag = this.companyTags.find((t) => t.id === this.inLogTagId);
            if (tag) {
                tags.push(tag);
                emitTagsChanged = true;
            }
        } else if (this.companyUser) {
            tags = this.companyUser.accessRights || [];
        } else if (this.invoiceProduct) {
            if (this.invoiceProduct.tag) {
                tags = [this.invoiceProduct.tag];
            }
        } else if (this.invoice) {
            tags = this.invoice.tags || [];
        }
        const model = [];
        if (tags && tags.length) {
            for (const tag of tags) {
                const documentTypes = getTagDocumentTypes(tag, tag.partitionTag);
                const color = getTagColor(tag, tag.partitionTag);

                // debugger
                model.push({
                    id: tag.id,
                    text: tag.name || tag.text,
                    type: tag.type,
                    partitionTag: tag.partitionTag,
                    primaryLog: tag.primaryLog,
                    color,
                    documentTypes: documentTypes,
                    disableDelete: tag.disableDelete,
                });
            }
        }
        this.model = model;
        if (emitTagsChanged) {
            this.emitTagsChanged();
        }
        this.fillPartitionModels();
    }

    beforeMount() {
        this.initializeUserActivity();
        this.updateModel();
    }

    @Watch("docmentId")
    @Watch("bankTransactionId")
    @Watch("accountingLineId")
    @Watch("companyUserId")
    @Watch("companyTags", { deep: true })
    @Watch("invoiceProductId")
    @Watch("invoiceId")
    onChanged(val, prev) {
        // if (val && prev && val.id === prev.id) return;
        this.updateModel();
    }

    skipOnModelChanged: boolean = false;
    skipOnStart: boolean = true;

    updatePrevCacheTags(result, tags) {
        //
        //
        //
        if (tags) {
            if (result.deletedCompanyTags && result.deletedCompanyTags.length) {
                result.deletedCompanyTags.forEach((tag) => {
                    const index = tags.findIndex((companyTag) => companyTag.id === tag);
                    if (index !== -1) {
                        tags.splice(index, 1);
                    }
                });
            }
            //
            if (result.createdCompanyTags)
                for (const tag of result.createdCompanyTags) {
                    if (!tag) {
                        debugger;
                        continue;
                    }
                    tags.push(tag);
                }
        }
    }

    onMutationEnded(result) {
        const { createdCompanyTags, connectedCompanyTags } = result;
        if (createdCompanyTags?.length) {
            for (const modelTag of this.model) {
                if (!modelTag.id) {
                    const createdTag = createdCompanyTags.find(
                        (acTag) => acTag.name === modelTag.text,
                    );
                    if (createdTag) {
                        modelTag.id = createdTag.id;
                    } else {
                        debugger;
                    }
                }
            }
        }

        //
        // snackbar
        //
        if (this.thirdPartyCompany && this.thirdPartyCompany.type !== "GENERIC") {
            if (createdCompanyTags?.length) {
                for (const tag of createdCompanyTags) {
                    if (!tag) {
                        debugger;
                        continue;
                    }
                    if (
                        (tag.type === "External" || tag.type === "TagDistribution") &&
                        !this.thirdPartyCompanyTags.find((cts) => cts.tag?.id === tag.id)
                    ) {
                        this.snackbar = {
                            tag: tag,
                            thirdPartyCompany: this.thirdPartyCompany,
                            loading: false,
                            display: true,
                        };
                    }
                }
            }
            if (connectedCompanyTags?.length) {
                for (const tag of connectedCompanyTags) {
                    if (!tag) {
                        debugger;
                        continue;
                    }
                    if (
                        (tag.type === "External" || tag.type === "TagDistribution") &&
                        !this.thirdPartyCompanyTags.find((cts) => cts.tag?.id === tag.id)
                    ) {
                        this.snackbar = {
                            tag: tag,
                            thirdPartyCompany: this.thirdPartyCompany,
                            loading: false,
                            display: true,
                        };
                    }
                }
            }
        }
    }

    manageExclusiveTag(model, tags, toRemoveTags) {
        for (const toAddTag of tags) {
            let found = false;
            if (
                this.onlyOneByPartition &&
                toAddTag.partitionTag &&
                toAddTag.partitionTag?.id !== "WithoutId"
            ) {
                for (let i = model.length - 1; i >= 0; i--) {
                    const valTag = model[i];
                    if (
                        valTag.id !== toAddTag.id &&
                        valTag.partitionTag?.id &&
                        valTag.partitionTag.id === toAddTag.partitionTag.id
                    ) {
                        toRemoveTags.push({
                            id: valTag.id,
                            type: valTag.type,
                            primaryLog: valTag.primaryLog,
                            partitionUniqueName: toAddTag.partitionTag.uniqueName,
                            partitionId: toAddTag.partitionTag.id,
                        });
                        model.splice(i, 1);
                        found = true;
                    }
                }
            }
            if (!found && toAddTag.primaryLog) {
                for (let i = model.length - 1; i >= 0; i--) {
                    const valTag = model[i];
                    if (
                        valTag.id !== toAddTag.id &&
                        valTag.primaryLog &&
                        valTag.primaryLog === toAddTag.primaryLog
                    ) {
                        toRemoveTags.push({
                            id: valTag.id,
                            type: valTag.type,
                            primaryLog: valTag.primaryLog,
                            partitionUniqueName: toAddTag.partitionTag?.uniqueName || undefined,
                            partitionId: toAddTag.partitionTag?.id || undefined,
                        });
                        model.splice(i, 1);
                    }
                }
            }
        }
    }

    computeModel(prev, val, toRemoveTags, toAddTagIds, toCreateTagNames) {
        const toAddTags = [];
        const toCreateTags = [];
        const toNotRemoveTags = [];
        let model = val
            .filter((tag) => !!tag)
            .map((tag) => {
                if (tag && typeof tag === "string") {
                    const lcTag = tag.toLowerCase();
                    let newTag = this.filteredCompanyTags.find(
                        (companyTag) => companyTag.text && companyTag.text.toLowerCase() === lcTag,
                    );
                    if (newTag) {
                        toAddTags.push(newTag);
                    } else {
                        newTag = {
                            id: "",
                            text: tag,
                            color: !this.selectedPrimaryLog ? "tagFree" : "tagLog",
                            type: "External",
                            partitionTag: this.selectedPartitionTagId
                                ? { id: this.selectedPartitionTagId }
                                : undefined,
                            primaryLog: this.selectedPrimaryLog || undefined,
                        };
                        newTag.color = getTagColor(newTag, this.selectedPartitionTag);
                        toCreateTagNames.push(tag);
                        toCreateTags.push(newTag);
                    }
                    return newTag;
                }
                if (
                    !tag.disableDelete &&
                    tag.type !== "SubAccountableAccount" &&
                    (!prev || !prev.find((prevTag) => prevTag.id === tag.id))
                ) {
                    toAddTags.push(tag);
                }
                return tag;
            });
        //
        // remove previous tag if necessary
        //
        if (prev) {
            // prev.forEach((prevTag) => {
            for (let index = 0; index < prev.length; index++) {
                const prevTag = prev[index];
                if (!model.find((modelTag) => modelTag.id === prevTag.id)) {
                    if (prevTag.id) {
                        if (prevTag.disableDelete && prevTag.type === "SubAccountableAccount") {
                            toNotRemoveTags.push({
                                index,
                                prevTag,
                            });
                        } else {
                            toRemoveTags.push({
                                id: prevTag.id,
                                type: prevTag.type,
                                primaryLog: prevTag.primaryLog,
                                partitionUniqueName: prevTag.partitionTag
                                    ? prevTag.partitionTag.uniqueName
                                    : undefined,
                                partitionId: prevTag.partitionTag?.id
                                    ? prevTag.partitionTag.id
                                    : undefined,
                            });
                        }
                    }
                }
            }
        }
        if (!this.multiple) {
            if (model.length > 1) {
                for (let index = 0; index < model.length - 1; index++) {
                    const tag = model[index];
                    toRemoveTags.push({
                        id: tag.id,
                        type: tag.type,
                        primaryLog: tag.primaryLog,
                        partitionUniqueName: tag.partitionTag
                            ? tag.partitionTag.uniqueName
                            : undefined,
                        partitionId: tag.partitionTag?.id ? tag.partitionTag.id : undefined,
                    });
                }
                model = [model[model.length - 1]];
            }
        } else {
            //
            // partitionTag : exclusive tag
            //
            if (toAddTags.length) {
                this.manageExclusiveTag(model, toAddTags, toRemoveTags);
            }
            if (toCreateTags.length) {
                this.manageExclusiveTag(model, toCreateTags, toRemoveTags);
            }
        }
        for (const toAddTag of toAddTags) {
            toAddTagIds.push({
                id: toAddTag.id,
                type: toAddTag.type,
                name: toAddTag.text,
                primaryLog: toAddTag.primaryLog,
                partitionUniqueName: toAddTag.partitionTag
                    ? toAddTag.partitionTag.uniqueName
                    : undefined,
                partitionId: toAddTag.partitionTag ? toAddTag.partitionTag.id : undefined,
            });
        }
        // debugger
        if (toNotRemoveTags.length) {
            for (const tag of toNotRemoveTags) {
                model.push(tag.prevTag);
            }
        }
        return model;
    }

    @Watch("model")
    async onModelChanged(val, prev) {
        if (this.skipOnStart) {
            this.skipOnStart = false;
            return;
        }
        if (this.skipOnModelChanged) return;
        if (val.length === prev.length) return;

        this.skipOnModelChanged = true;
        const toRemoveTags = [];
        const toAddTagIds = [];
        const toCreateTags = [];
        this.model = this.computeModel(prev, val, toRemoveTags, toAddTagIds, toCreateTags);
        this.fillPartitionModels();

        if (
            this.document?.id ||
            this.invoice?.id ||
            this.accountingLine?.id ||
            this.bankTransaction?.id ||
            this.createIfMissing
        ) {
            if (toRemoveTags.length || toAddTagIds.length || toCreateTags.length) {
                // const toAddTagIds = toAddTags.map(toAddTag => toAddTag.id);
                if (this.invoice) {
                    this.invoice.tags = this.model;
                    await this.$apollo.mutate({
                        mutation: UPDATE_INVOICE_TAGS,
                        variables: {
                            companyId: this.companyId,
                            ids: [this.invoice.id],
                            toRemoveTags: toRemoveTags,
                            toAddTags: toAddTagIds,
                            toCreateTags: toCreateTags,
                            partitionTagId: this.forCreationPartitionTagId,
                            primaryLog: this.selectedPrimaryLog,
                        },
                        update: (cache, { data }) => {
                            try {
                                if (data.updateDocumentsTags?.docAlModified) {
                                    this.emitTagsChanged();
                                }
                                this.onMutationEnded(data.updateDocumentsTags);
                            } catch (e) {
                                debugger;
                                // We should always catch here,
                                // as the cache may be empty or the query may fail
                            }
                        },
                    });
                } else if (this.document) {
                    this.document.tags = this.model;
                    await this.$apollo.mutate({
                        mutation: UPDATE_DOCUMENT_TAGS,
                        variables: {
                            companyId: this.companyId,
                            ids: [this.document.id],
                            toRemoveTags: toRemoveTags,
                            toAddTags: toAddTagIds,
                            toCreateTags: toCreateTags,
                            partitionTagId: this.forCreationPartitionTagId,
                            primaryLog: this.selectedPrimaryLog,
                        },
                        update: (cache, { data }) => {
                            try {
                                // const prevCache = cache.readQuery({
                                //     query: COMPANY_TAG_QUERY,
                                //     variables:
                                //     {
                                //         companyId: this.companyId
                                //     }
                                // });
                                // if (prevCache && (prevCache as any).tags) {
                                //     const { tags } = (prevCache as any);
                                //     if (tags) {
                                //         this.updatePrevCacheTags(data.updateDocumentsTags, tags)
                                //         cache.writeQuery({
                                //             query: COMPANY_TAG_QUERY,
                                //             data: {
                                //                 tags
                                //             }
                                //         });
                                if (data.updateDocumentsTags?.docAlModified) {
                                    this.emitTagsChanged();
                                }
                                //     }
                                // }
                                this.onMutationEnded(data.updateDocumentsTags);
                            } catch (e) {
                                debugger;
                                // We should always catch here,
                                // as the cache may be empty or the query may fail
                            }
                        },
                    });
                    // await this.tagActivity()
                } else if (this.bankTransaction) {
                    this.bankTransaction.tags = this.model;
                    await this.$apollo.mutate({
                        mutation: UPDATE_BANKTRANSACTION_TAGS,
                        variables: {
                            companyId: this.companyId,
                            ids: [this.bankTransactionId],
                            toRemoveTags: toRemoveTags,
                            toAddTags: toAddTagIds,
                            toCreateTags: toCreateTags,
                            partitionTagId: this.forCreationPartitionTagId,
                            primaryLog: this.selectedPrimaryLog,
                        },
                        update: (cache, { data }) => {
                            try {
                                // const prevCache = cache.readQuery({
                                //     query: COMPANY_TAG_QUERY,
                                //     variables:
                                //     {
                                //         companyId: this.companyId
                                //     }
                                // });
                                // if (prevCache && (prevCache as any).tags) {
                                //     const { tags } = (prevCache as any);
                                //     if (tags) {
                                //         this.updatePrevCacheTags(data.updateDocumentsTags, tags)
                                //         cache.writeQuery({
                                //             query: COMPANY_TAG_QUERY,
                                //             data: {
                                //                 tags
                                //             }
                                //         });
                                if (data.updateDocumentsTags?.docAlModified) {
                                    this.emitTagsChanged();
                                }
                                //     }
                                // }
                                this.onMutationEnded(data.updateDocumentsTags);
                            } catch (e) {
                                debugger;
                                // We should always catch here,
                                // as the cache may be empty or the query may fail
                            }
                        },
                    });
                } else if (this.accountingLine) {
                    const result = await this.$apollo.mutate({
                        mutation: UPDATE_ACCOUNTINGLINE_TAGS,
                        variables: {
                            companyId: this.companyId,
                            accountingLineId: this.accountingLine.id,
                            toRemoveTags: toRemoveTags,
                            toAddTags: toAddTagIds,
                            toCreateTags: toCreateTags,
                            partitionTagId: this.forCreationPartitionTagId,
                            primaryLog: this.selectedPrimaryLog,
                        },
                        update: (cache, { data }) => {
                            try {
                                // const prevCache = cache.readQuery({
                                //     query: COMPANY_TAG_QUERY,
                                //     variables:
                                //     {
                                //         companyId: this.companyId
                                //     }
                                // });
                                // if (prevCache && (prevCache as any).tags) {
                                //     const { tags } = (prevCache as any);
                                //     if (tags) {
                                //         this.updatePrevCacheTags(data.updateAccountingLineTags, tags)
                                //         cache.writeQuery({
                                //             query: COMPANY_TAG_QUERY,
                                //             data: {
                                //                 tags
                                //             }
                                //         });
                                this.emitTagsChanged();
                                //     }
                                // }
                                this.onMutationEnded(data.updateAccountingLineTags);
                            } catch (e) {
                                debugger;
                                // We should always catch here,
                                // as the cache may be empty or the query may fail
                            }
                        },
                    });
                } else if (this.createIfMissing) {
                    if (toCreateTags.length) {
                        const result = await this.$apollo.mutate({
                            mutation: UPDATE_TAGS_QUERY,
                            variables: {
                                companyId: this.companyId,
                                toRemoveTags: toRemoveTags,
                                toAddTags: toAddTagIds,
                                toCreateTags: toCreateTags,
                                partitionTagId: this.forCreationPartitionTagId,
                                primaryLog: this.selectedPrimaryLog,
                            },
                            update: (cache, { data }) => {
                                try {
                                    // const prevCache = cache.readQuery({
                                    //     query: COMPANY_TAG_QUERY,
                                    //     variables:
                                    //     {
                                    //         companyId: this.companyId
                                    //     }
                                    // });
                                    // if (prevCache && (prevCache as any).tags) {
                                    //     const { tags } = (prevCache as any);
                                    //     if (tags) {
                                    //         this.updatePrevCacheTags(data.updateTags, tags)
                                    //         cache.writeQuery({
                                    //             query: COMPANY_TAG_QUERY,
                                    //             data: {
                                    //                 tags
                                    //             }
                                    //         });
                                    //     }
                                    // }
                                    this.onMutationEnded(data.updateTags);
                                    this.emitTagsChanged();
                                } catch (e) {
                                    debugger;
                                    // We should always catch here,
                                    // as the cache may be empty or the query may fail
                                }
                            },
                        });
                    } else {
                        this.emitTagsChanged();
                    }
                }
            }
        } else {
            this.$emit("updateTags", {
                toRemoveTags,
                toAddTags: toAddTagIds,
                toCreateTags,
            });
            this.emitTagsChanged();
        }
        this.selectedPartitionTag = null;
        this.skipOnModelChanged = false;
    }

    emitTagsChanged() {
        const tags = [];
        for (const tag of this.model) {
            tags.push({
                id: tag.id,
                name: tag.text,
                primaryLog: tag.primaryLog,
            });
        }
        this.$emit("onTagsChanged", {
            accountingLineId: this.accountingLineId,
            tags,
        });
    }

    edit(index, item) {
        if (!this.editing) {
            this.editing = item;
            this.index = index;
        } else {
            this.editing = null;
            this.index = -1;
        }
    }

    filter(item, queryText, itemText) {
        if (item.header) return false;

        const hasValue = (val) => (val != null ? val : "");

        const text = hasValue(itemText);
        const query = hasValue(queryText);

        return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
    }

    isRemoveable(item) {
        if (item.type === "SubAccountableAccount" || item.disableDelete) return false;
        return (
            item.type === "External" || item.type === "Internal" || item.type === "TagDistribution"
        );
    }

    isEditable(item) {
        if (item.type === "SubAccountableAccount" || item.disableDelete) return false;
        return item.type === "External";
    }

    tagExists() {
        if (this.searchText) {
            const searchText = this.searchText.toLowerCase();
            return !!this.filteredCompanyTags.find(
                (t) => !!t.text && t.text.toLowerCase() === searchText,
            );
        }
        return false;
    }

    addNewTagLoading: boolean = false;

    addNewTag() {
        if (this.searchText) {
            this.addNewTagLoading = true;
            const index = this.model.findIndex((t) => t.text === this.search);
            if (index === -1) {
                const prev = JSON.parse(JSON.stringify(this.model));
                if (this.multiple) {
                    this.model.push(this.searchText);
                } else {
                    this.model = [this.searchText];
                }
                this.onModelChanged(this.model, prev);
            }
            this.searchText = "";
        }
        if (this.syncedInDialog === null) {
            this.dialog = false;
        }
    }

    addTagLoading: boolean = false;

    addTag(item) {
        const index = this.model.findIndex((t) => t.id === item.id);
        if (index === -1) {
            this.addTagLoading = true;
            const prev = JSON.parse(JSON.stringify(this.model));
            if (this.multiple) {
                this.model.push(item);
            } else {
                this.model = [item];
            }
            this.onModelChanged(this.model, prev);
            this.addTagLoading = true;
        }
        this.searchText = "";
        if (this.syncedInDialog === null) {
            this.dialog = false;
        }
    }

    initializeUserActivity() {
        this.activity = new UserActivity("CREATE", "DOCUMENT", moment());
    }

    async createUserActivity(documentId, action) {
        await this.activity.create(
            this.$apollo,
            this.currentUser.id,
            this.companyId,
            documentId,
            action,
        );
        this.initializeUserActivity();
    }

    tagGate() {
        this.timeGate = false;
    }

    // async tagActivity() {
    //     if (this.timeGate) {
    //         try {
    //             // if (this.id) {
    //             //     await this.createUserActivity(this.id, "TAG")
    //             // }
    //             if (this.document?.id){
    //                 await this.createUserActivity(this.document.id, "TAG")
    //             }
    //         } catch(e) {
    //             console.error(e)
    //         }
    //     } else {
    //         this.timeGate = true
    //     }
    // }

    removeItem(item) {
        const index = this.model.findIndex((t) => t.id === item.id);
        if (index !== -1) {
            // const prev = JSON.parse(JSON.stringify(this.model));
            this.model.splice(index, 1);
            // this.onModelChanged(this.model, prev);
        }
    }

    removeItemWithIndex(index) {
        // ensure reactivity
        this.model = this.model.filter((_, i) => i !== index);
    }

    get snackbarText() {
        return this.getSnackbarText(this.snackbar);
    }

    getSnackbarText(snackbar) {
        if (!snackbar) {
            return "";
        }
        if (!snackbar.tag) {
            return "";
        }
        const tagName = snackbar.tag.name || snackbar.tag.text;
        let text = "Toujours appliquer l'étiquette \"" + tagName + '" au fournisseur "';
        text += snackbar.thirdPartyCompany.name + '"';

        return text;
    }

    async createSuggestion(snackbar) {
        if (!snackbar) {
            console.info("No snackbar");
            return;
        }
        snackbar.loading = true;
        if (snackbar.tag && snackbar.thirdPartyCompany && this.companyId) {
            await this.$apollo
                .mutate({
                    mutation: CREATE_THIRDPARTYCOMPANY_TAG_RULE,
                    variables: {
                        companyId: this.companyId,
                        thirdPartyCompanyId: snackbar.thirdPartyCompany.id,
                        tagId: snackbar.tag.id,
                    },
                })
                .catch((err) => {});
        }
        snackbar.display = false;
        snackbar.loading = false;
        this.$emit("tagRuleApplyOnThirdPartyCompany");
    }

    // --------------------
    // split partitionTag -
    // --------------------

    get partitionTags(): Array<PartitionTags> {
        // return buildPartitionTagsFromCompanyTags(this.filteredCompanyTags)
        const partitionTags = [];
        if (this.splitUserPartitions) {
            for (const tag of this.filteredCompanyTags) {
                if (tag.header) {
                    continue;
                }
                let partitionTag = partitionTags.find(
                    (pt) => pt.partitionTag.id === tag.partitionTag.id,
                );
                if (!partitionTag) {
                    partitionTag = {
                        model: [],
                        search: "",
                        partitionTag: tag.partitionTag,
                        tags: [],
                    };
                    partitionTags.push(partitionTag);
                }
                partitionTag.tags.push(tag);
            }
        }

        return partitionTags;
    }

    fillPartitionModels() {
        if (this.splitUserPartitions && this.partitionTags.length) {
            for (const partition of this.partitionTags) {
                if (partition.model.length) {
                    partition.model.splice(0, partition.model.length);
                }
            }
            for (const tag of this.model) {
                if (tag.partitionTag?.id) {
                    const partition = this.partitionTags.find(
                        (p) => p.partitionTag?.id === tag.partitionTag.id,
                    );
                    if (partition) {
                        partition.model.push(tag);
                    }
                } else if (tag.primaryLog) {
                    const partition = this.partitionTags.find(
                        (p) => p.partitionTag?.primaryLog === tag.primaryLog,
                    );
                    if (partition) {
                        partition.model.push(tag);
                    }
                } else {
                    const partition = this.partitionTags.find(
                        (p) => p.partitionTag?.id === "WithoutId",
                    );
                    if (partition) {
                        partition.model.push(tag);
                    }
                }
            }
        }
    }

    // modifiedPartitionTagId:string = ""

    selectedPartitionTag: any = null;

    get selectedPartitionTagId(): string {
        if (this.partitionTagId) {
            return this.partitionTagId;
        }
        return this.selectedPartitionTag?.id || undefined;
    }

    get forCreationPartitionTagId() {
        return this.selectedPartitionTagId && this.selectedPartitionTagId !== "WithoutId"
            ? this.selectedPartitionTagId
            : undefined;
    }

    // selectedPrimaryLog_:string = ""
    get selectedPrimaryLog() {
        if (this.partitionTagId) {
            return undefined;
        }
        return this.selectedPartitionTag?.primaryLog || undefined;
    }

    async onPartitionTagChanged(partitionTag) {
        await this.$nextTick();
        this.selectedPartitionTag = partitionTag?.partitionTag || null;
        // this.modifiedPartitionTagId = partitionTag?.partitionTag?.id || ""
        // this.selectedPrimaryLog_ = partitionTag?.partitionTag?.primaryLog || ""
        const model = [];
        for (const partition of this.partitionTags) {
            model.push(...partition.model);
        }
        this.model = model;
    }
}

type Tag = {
    id: string;
    header?: boolean;
    text: string;
    type: string;
    partitionTag?: PartitionTag;
    primaryLog: string;
    color: string;
    documentTypes?: string;
    disableDelete?: boolean;
};

type PartitionTag = {
    id: string;
    name?: string;
    primaryLog?: string;
    type?: string;
    uniqueName?: string;
};

type PartitionTags = {
    partitionTag: PartitionTag;
    tags: Tag[];
    model: Tag[];
    search: string;
};
